import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import PageHeading from '../../../../components/PageHeading'
import ProjectImage from "../../../../assets/images/landimg.png"
import AllKhasra from './AllKhasra'
import UpdateProject from '../../../../APIs/Project/UpdateProject'
import Loader from '../../../../components/Loader'
import GetLandDetailsByProjectId from '../../../../APIs/Land/GetLandDetailsByProjectId'
import SideMessage from '../../../../components/SideMessage'
import ProjectAllPlot from '../../../Project Portfolio/ProjectAllPlot'

export default function ProjectDetails({ setLandId, projectDataOut, setProjectNameGlobal, isUpdatePortfolio, finalProductionCost,totalArea }) {
    const [projectData, setProjectData] = useState([])
    const [projectName, setProjectName] = useState("")
    const navigate = useNavigate();
    const [landmark, setLandmark] = useState("")
    const [loader, setLoader] = useState(false)
    const [sideToster, setSideToster] = useState({
        show: false,
        message: '',
        type: ''
    })

    const [sendForm, setSendForm] = useState({
        name: "",
        landmark: "",
        latitude: "",
        longitude: "",
        isApproved: false,
        approvedBy: "",
        rerano: "",
        projectImageUrl: "",
        projectImage: null
    })

    const getImageUrl = (url) => {
        if (!url) return "";
        if (url.startsWith("http://") || url.startsWith("https://")) return url;
        return `https://adminapi.vifadevelopers.com${url.startsWith("/") ? "" : "/"}${url}`;
    }

    const handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setSendForm({ ...sendForm, [name]: value });
    }

    const resetForm = (data = projectData) => {
        if (data) {
            setSendForm({
                name: data.name || "",
                landmark: data.landmark || "",
                latitude: data.latitude || "",
                longitude: data.longitude || "",
                isApproved: data.isAuthorized ?? data.isApproved ?? false,
                approvedBy: data.approvedBy || data.ApprovedBy || "",
                rerano: data.rerano || data.Rerano || "",
                projectImageUrl: data.projectImageUrl || "",
                projectImage: null
            });
            setProjectName(data.name || "");
            setLandmark(data.landmark || "");
        }
    }

    const handleSaveForm = async () => {
        if (sendForm.name && sendForm.landmark) {
            setLoader(true)
            const payload = {
                id: projectData.id,
                projectNo: projectData.projectNo ? (typeof projectData.projectNo === 'string' ? projectData.projectNo.slice(7, 10) : projectData.projectNo) : "",
                name: sendForm.name,
                landmark: sendForm.landmark,
                latitude: sendForm.latitude,
                longitude: sendForm.longitude,
                isAuthorized: sendForm.isApproved,
                approvedBy: sendForm.approvedBy,
                rerano: sendForm.rerano,
                userId: projectData.userId || window.userId
            }

            const resp = await UpdateProject(payload)
            if (resp.status === 1) {
                const projectSessionData = JSON.parse(window.sessionStorage.getItem("ProjectData"))
                window.sessionStorage.setItem("ProjectData", JSON.stringify({
                    ...projectSessionData,
                    projectData: {
                        projectName: sendForm.name,
                        projectNo: projectData.projectNo,
                        projectId: projectData.id,
                        projectPrice: projectData.totalLandPrice,
                        projectArea: projectData.totalLandArea,
                        landmark: sendForm.landmark
                    },
                }))
                setProjectNameGlobal(sendForm.name)
                setProjectName(sendForm.name)
                setLandmark(sendForm.landmark)
                setProjectData({
                    ...projectData,
                    name: sendForm.name,
                    landmark: sendForm.landmark,
                    latitude: sendForm.latitude,
                    longitude: sendForm.longitude,
                    isAuthorized: sendForm.isApproved,
                    approvedBy: sendForm.approvedBy,
                    rerano: sendForm.rerano
                })
                setSideToster({
                    show: true,
                    message: "Project Details Updated!",
                    type: 'Success'
                })
            } else {
                setSideToster({
                    show: true,
                    message: "Something Went Wrong!",
                    type: 'Alert'
                })
            }
            setLoader(false)
        } else {
            setSideToster({
                show: true,
                message: "Please Fill Fields!",
                type: 'Alert'
            })
        }
    }

    useEffect(() => {
        setProjectData(projectDataOut)
        resetForm(projectDataOut)
    }, [projectDataOut])
    return (
        <>
            {projectName && (
                <div className='container-fluid landformconatiner p-4' style={{ maxHeight: "100%" }}>
                    <div className='d-flex flex-row justify-content-between'>
                        <PageHeading pagename={projectName} />
                        <button className='editProject' data-bs-toggle="modal" data-bs-target="#addproject">
                            <i className="fa-regular fa-pen-to-square fa-lg"></i>&nbsp; Edit Details
                        </button>
                    </div>
                    <div className='row'>
                        <span className='text-secondary'>#{landmark}</span>
                    </div>
                    <div className='row pt-3'>
                        {/* <img src={ProjectImage} alt="Project" width="100%" height="100%" /> */}
                        <div onClick={() => { navigate('/plotspecification/' + projectData.id) }}>
                            <ProjectAllPlot projectId={projectData.id} isComponent={1} />
                        </div>
                    </div>
                    <div className='d-flex flex-row justify-content-between pt-3'>
                        <PageHeading pagename={`₹ ${projectData.totalLandPrice}`} />
                        {
                            isUpdatePortfolio ?

                                <div className='d-flex flex-row justify-content-center align-items-center gap-2'>
                                    <i className="fa-solid fa-location-arrow locationIcon"></i>
                                    <Link to={`/plotdefine/${finalProductionCost}/${totalArea}`}>
                                        <span className='locationtext'>Update Plot Specification</span>
                                    </Link>
                                </div>
                                : <></>
                        }
                    </div>
                    <div className='d-flex flex-column gap-3 pt-3'>
                        <div className='d-flex flex-row align-items-center gap-3'>
                            <i className="fa-solid fa-up-right-and-down-left-from-center project-icon"></i>
                            <span className='d-flex flex-column gap-1'>
                                <label className='heading-project'>Total Land Area</label>
                                <label className='heading-project' style={{ color: "#737791" }}>
                                    {(projectData.totalLandArea)?.toFixed(2)} {projectData.unitName || "sq"}
                                </label>
                            </span>
                        </div>
                        <div className='d-flex flex-row align-items-center gap-3'>
                            <i className="bi bi-geo-alt-fill project-icon"></i>
                            <span className='d-flex flex-column gap-1'>
                                <label className='heading-project'>Location</label>
                                <label className='heading-project' style={{ color: "#737791" }}>{landmark}</label>
                            </span>
                        </div>
                    </div>
                    <AllKhasra setLandId={setLandId} />

                    {/* Modal */}
                    <div className="modal  fade " id="addproject" tabindex="-1" aria-labelledby="addprojectLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content pt-3 ps-3 pe-3 pb-1" style={{ maxWidth: "500px" }}>
                                <div className="modal-header">
                                    <h1 className="modal-title fs-5 text-primary" id="addprojectLabel">Update Project</h1>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => resetForm()}></button>
                                </div>
                                <div className="modal-body">
                                    <div className='row pb-4'>
                                        <div className='col pb-2 pb-md-0'>
                                            <div className='d-flex flex-column gap-1'>
                                                <label className='form-label'>Project Name</label>
                                                <input type='text' className='form-input-box' placeholder='Enter Project Name' value={sendForm.name} name="name" onChange={handleChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row pb-4'>
                                        <div className='col pb-2 pb-md-0'>
                                            <div className='d-flex flex-column gap-1'>
                                                <label className='form-label'>Landmark</label>
                                                <input type='text' className='form-input-box' placeholder='Enter Landmark' value={sendForm.landmark} name="landmark" onChange={handleChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row pb-4'>
                                        <div className='col pb-2 pb-md-0'>
                                            <div className='d-flex flex-column gap-1'>
                                                <label className='form-label'>Latitude</label>
                                                <input type='text' className='form-input-box' placeholder='Enter Latitude' value={sendForm.latitude} name="latitude" onChange={handleChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row pb-4'>
                                        <div className='col pb-2 pb-md-0'>
                                            <div className='d-flex flex-column gap-1'>
                                                <label className='form-label'>Longitude</label>
                                                <input type='text' className='form-input-box' placeholder='Enter Longitude' value={sendForm.longitude} name="longitude" onChange={handleChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row pb-4'>
                                        <div className='col pb-2 pb-md-0'>
                                            <div className='d-flex flex-column gap-1'>
                                                <label className='form-label'>Is Approved</label>

                                                <select
                                                    className='form-input-box'
                                                    name="isApproved"
                                                    value={sendForm.isApproved ?? ""}
                                                    onChange={(e) =>
                                                        setSendForm({
                                                            ...sendForm,
                                                            isApproved: e.target.value === "true"
                                                        })
                                                    }
                                                >
                                                    <option value="false">Not Approved</option>
                                                    <option value="true">Approved</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {sendForm.isApproved === true && 
                                    <div className='row pb-4'>
                                        <div className='col pb-2 pb-md-0'>
                                            <div className='d-flex flex-column gap-1'>
                                                <label className='form-label'>Approved By</label>

                                                <select
                                                    className='form-input-box'
                                                    name="approvedBy"
                                                    value={sendForm.approvedBy ?? ""}
                                                    onChange={(e) =>
                                                        setSendForm({
                                                            ...sendForm,
                                                            approvedBy: e.target.value 
                                                        })
                                                    }
                                                >
                                                    <option value="">Select</option>
                                                    <option value="LDA">LDA</option>
                                                    <option value="Nagar Nigam">Nagar Nigam</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>}

                                    <div className='row pb-4'>
                                        <div className='col pb-2 pb-md-0'>
                                            <div className='d-flex flex-column gap-1'>
                                                <label className='form-label'>Rera No.</label>
                                                <input type='text' className='form-input-box' placeholder='Enter Rera No.' value={sendForm.rerano} name="rerano" onChange={handleChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row pb-4'>
                                        <div className='col pb-2 pb-md-0'>
                                            <div className='d-flex flex-column gap-1'>
                                                <label className='form-label'>Project Image</label>

                                                {(sendForm.projectImage || projectData?.projectImageUrl || sendForm.projectImageUrl) && (
                                                    <div className="mb-2">
                                                        <img
                                                            src={
                                                                sendForm.projectImage
                                                                    ? URL.createObjectURL(sendForm.projectImage)
                                                                    : getImageUrl(projectData?.projectImageUrl || sendForm.projectImageUrl)
                                                            }
                                                            alt="Project"
                                                            style={{
                                                                width: "100%",
                                                                maxHeight: "180px",
                                                                objectFit: "cover",
                                                                borderRadius: "8px",
                                                                border: "1px solid #dee2e6"
                                                            }}
                                                        />
                                                    </div>
                                                )}

                                                <input
                                                    type="file"
                                                    className='form-input-box'
                                                    accept="image/*"
                                                    onChange={(e) =>
                                                        setSendForm({
                                                            ...sendForm,
                                                            projectImage: e.target.files[0]
                                                        })
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer" >
                                    <button type="button" style={{ width: "100%" }} className="btn btn-primary" onClick={handleSaveForm} data-bs-dismiss="modal" aria-label="Close">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {sideToster.show && <SideMessage close={setSideToster} show={sideToster.show} type={sideToster.type} message={sideToster.message} />}
            <Loader show={loader} />
        </>
    )
}
